import { render, staticRenderFns } from "./GBook.vue?vue&type=template&id=05d5816e&scoped=true&"
import script from "./GBook.vue?vue&type=script&lang=js&"
export * from "./GBook.vue?vue&type=script&lang=js&"
import style0 from "./GBook.vue?vue&type=style&index=0&id=05d5816e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d5816e",
  null
  
)

export default component.exports